<template>
  <page-layout title="서비스 로그">
    <template v-slot:search>
      <service-log-search-bar
        @search="getSearch"
      />
    </template>
    <template v-slot:table>
      <service-log-table
        :data="data"
        :loading="loading"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import ServiceLogSearchBar from "@/pages/Etc/components/ServiceLogSearchBar.vue";
import {axiosInstance} from "@/util/AxiosModule";
import ServiceLogTable from "@/pages/Etc/components/ServiceLogTable.vue";

export default {
  name: "ServiceLog",
  components: {ServiceLogTable, ServiceLogSearchBar, PageLayout},
  data() {
    return {
      data: [],
      loading: false
    }
  },
  methods: {
    async getSearch(params) {
      this.loading = true;
      try {
        const { data } = await axiosInstance.get("/admin/operation/api-hist", { params });
        if (data.length < 1) {
          this.data = [];
        } else {
          this.data = data;
        }
      } catch (e) {
        await this.showAlert({message: `${e.response.data.message}`});
      }
      this.loading = false;
    }
  }
}
</script>